import axiosInstance from "./axiosInstance.ts";

export interface ShareEventTicket {
    phoneNumber: string;
    lastName: string;
    firstName: string;
    code: string;
}

export const shareEventTicket = async (
    data: ShareEventTicket
): Promise<{ data: unknown }> => {
    const payload = {
        phoneNumber: data.phoneNumber,
        firstName: data.firstName,
        lastName: data.lastName,
    };
    const res = await axiosInstance.post(
        `/vouchers/change/holder/${data.code}`,
        payload
    );
    return res;
}
